// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c102ea8","698":"9750c57b","787":"c6e09949","807":"bed61b26","828":"ec01d57c","937":"2c63a93f"}[chunkId] + ".chunk.js";
};